import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import '../../css/FutureReadiness.css';
import 'react-datepicker/dist/react-datepicker.css';
import { Button, Dropdown, Icon, Message } from 'semantic-ui-react';

// ─── DateInput trigger ────────────────────────────────────────────────────────

const DateInput = forwardRef(({ value, onClick, placeholder }, ref) => (
    <div
        ref={ref}
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && onClick(e)}
        className="fr-date-input"
    >
        <span className={`fr-date-input__text${value ? ' fr-date-input__text--filled' : ''}`}>
            {value || placeholder}
        </span>
        <Icon name="calendar outline" className="fr-date-input__icon" />
    </div>
));

// ─── FutureReadinessFilters ───────────────────────────────────────────────────

export const FutureReadinessFilters = ({
    startDate, setStartDate,
    endDate, setEndDate,
    selectedTeamIds, setSelectedTeamIds,
    teamOptions,
    teamsLoading,
    loading, exporting,
    onGenerate, onExport,
    error, setError,
}) => {
    return (
        <div className="fr-filters-card">
            <div className="fr-filters-title">
                Filters
            </div>

            <div className="fr-filters-row">

                {/* Start date */}
                <div>
                    <div className="fr-field-label">Start Date</div>
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => { setStartDate(date); setError(''); }}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        customInput={<DateInput placeholder="Start date" />}
                        dateFormat="MM/dd/yyyy"
                    />
                </div>

                {/* End date */}
                <div>
                    <div className="fr-field-label">End Date</div>
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => { setEndDate(date); setError(''); }}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        customInput={<DateInput placeholder="End date" />}
                        dateFormat="MM/dd/yyyy"
                    />
                </div>

                {/* Team selector — multi-select for ICC Support, single-select for others */}
                <div className="fr-team-selector">
                    <div className="fr-field-label">
                        Teams <span className="fr-field-label__optional">(optional)</span>
                    </div>
                    <Dropdown
                        placeholder={teamsLoading ? 'Loading teams…' : 'All teams'}
                        fluid
                        multiple
                        selection
                        search
                        clearable
                        options={teamOptions}
                        value={selectedTeamIds}
                        onChange={(_, { value }) =>
                            setSelectedTeamIds(value)
                        }
                        loading={teamsLoading}
                        disabled={teamsLoading}
                    />
                </div>

                {/* Action buttons */}
                <div className="fr-filters-actions">
                    <Button
                        primary
                        icon
                        labelPosition="left"
                        onClick={onGenerate}
                        loading={loading}
                        disabled={loading || exporting}
                    >
                        <Icon name="chart bar" />
                        Generate Report
                    </Button>
                    <Button
                        color="green"
                        icon
                        labelPosition="left"
                        onClick={onExport}
                        loading={exporting}
                        disabled={loading || exporting}
                    >
                        <Icon name="file excel" />
                        Export to Excel
                    </Button>
                </div>
            </div>

            {error && (
                <Message negative className="fr-filters-error">
                    <Icon name="exclamation circle" />
                    {error}
                </Message>
            )}
        </div>
    );
};
